import { Card } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Wager } from "../types";
import WagerOutcomes from "./WagerOutcomes";

interface WagerListItemProps {
  wager: Wager;
}

export default function WagerListItem(props: WagerListItemProps) {
  var navigate = useNavigate();

  return (
    <div onClick={() => navigate(`/wagers/${props.wager.id}`)}>
      <Card className="p-3 mt-3" style={{ cursor: "pointer" }}>
        <Card.Body>
          <Card.Title>
            <h3>{props.wager.title}</h3>
          </Card.Title>
          <Card.Text>
            <h4>Bets placed</h4>
            <p>{props.wager.bets.length}</p>
            <h4>Outcomes</h4>
            <WagerOutcomes wager={props.wager} />
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
}
